import "./polyfills";
import React from "react";
import { createRoot } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { GlobalModalContextProvider } from "src/utils/GlobalModal/GlobalModalContext";
import getEnvironmentConfig from "src/utils/env/getEnvironmentConfig";
import InspectorWrapper from "./devInspector/prod";
import * as serviceWorker from "./serviceWorker";
import "./assets/base.scss";
import Main from "./Pages/Main";
import configureStore from "./config/configureStore";
import getUserConfirmationPopup from "./utils/system/DOM/getUserConfirmationPopup";
import RbsAppWrapper from "./utils/RoleBasedSecurity/RbsAppWrapper";
import ScrollToTop from "./Layout/AppMain/ScrollToTop";
import { getVersion } from "./config/env";
import { FeatureFlagsProvider } from "./utils/FeatureFlags/FeatureFlagsContext";
import GrowthbookFeatureFlagsProvider from "./utils/GrowthBookFeatureFlags/FeatureFlagsProvider";
import GlobalErrorBoundary from "./Layout/AppMain/GlobalErrorBoundary";

const VERSION_KEY = "version";
const store = configureStore();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const featureFlags = {
  apiUrl: process.env.REACT_APP_FEATURE_FLAGS_URL || "",
};

const configs = getEnvironmentConfig();

let growthbookClientKey = "sdk-f9CAUhc7w8kNqh3Q";

let growthbookDevMode = false;

window.permissionsUrl = "https://api.dev.aws.mybenefit.pl";
window.payrollModuleUrl = "https://saas-api.wynagrodzenia.dev.aws.mybenefit.pl";

window.reportingToolUrl = configs.reportingTool;
window.adminSelfUrl = configs.adminSelfUrl;
window.permissionsUrl = configs.permissionsUrl;
window.payrollModuleUrl = configs.payrollModuleUrl;

growthbookClientKey = configs.growthbookClientKey;
growthbookDevMode = configs.growthbookDevMode;
featureFlags.apiUrl = configs.featureFlags;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: false, // default: 3
    },
  },
});

if (process.env.NODE_ENV !== "development") {
  // eslint-disable-next-line global-require
  const newrelic = require("./utils/newRelic/newRelicAgent/newrelic").default;

  newrelic();
}

const renderApp = (Component) => {
  const version = localStorage?.getItem(VERSION_KEY);

  if (!version || version !== getVersion()) {
    localStorage?.clear();
    sessionStorage?.clear();
    localStorage?.setItem(VERSION_KEY, getVersion());
  }

  root.render(
    <GlobalErrorBoundary>
      <InspectorWrapper
        keys={["control", "alt", "z"]}
        disableLaunchEditor={false}
        onHoverElement={(params) => {}}
        onClickElement={(params) => {}}
      >
        <Provider store={store}>
          <FeatureFlagsProvider options={featureFlags}>
            <RbsAppWrapper>
              <GrowthbookFeatureFlagsProvider
                clientKey={growthbookClientKey}
                enableDevMode={growthbookDevMode}
              >
                <BrowserRouter getUserConfirmation={getUserConfirmationPopup}>
                  <QueryClientProvider client={queryClient}>
                    <GlobalModalContextProvider>
                      <ScrollToTop />
                      <Component />
                    </GlobalModalContextProvider>
                  </QueryClientProvider>
                </BrowserRouter>
              </GrowthbookFeatureFlagsProvider>
            </RbsAppWrapper>
          </FeatureFlagsProvider>
        </Provider>
      </InspectorWrapper>
    </GlobalErrorBoundary>
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./Pages/Main", () => {
    // eslint-disable-next-line global-require
    const NextApp = require("./Pages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
